<template>
  <div class="com-container relative">
    <div id="login">
      <div class="login-box">
        <img src="../assets/images/logo.png" width="100%" />
        <div class="i-content">
          <div class>
            <label for>账号：</label>
            <input
              type="text"
              name="username"
              v-model="username"
              autocomplete="off"
              class
            />
          </div>
          <div class="i-possword">
            <label for>密码：</label>
            <input
              type="password"
              name="password"
              v-model="password"
              autocomplete="off"
              class
            />
          </div>
          <div class="memory">
            <el-checkbox v-model="memory" value="1">记住密码</el-checkbox>
          </div>
          <div class="text-center">
            <img
              src="../assets/images/btn.png"
              width="150"
              @click="login_check"
              class="img-submit center-block"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  name: "Index",

  data() {
    return {
      username: "",
      password: "",
      memory: "",
      deviceNum: "",
    };
  },
  mounted: function () {
    if (localStorage.getItem("memory") == "记住密码") {
      this.memory = true;
      this.username = localStorage.getItem("username");
      this.password = localStorage.getItem("password");
    } else {
      this.memory = false;
    }

    if (localStorage.getItem("deviceNum")) {
      this.deviceNum = localStorage.getItem("deviceNum");
    } else {
      var deviceNum = this.uuid(); //自定义机器码
      localStorage.setItem("deviceNum", deviceNum);
      this.deviceNum = deviceNum;
    }
    console.log(this.deviceNum);
    //获取机器码
    // this.$axios({
    //   method: "GET",
    //   url: this.apiTp5Url + "/GetMacAddr",
    //   params: {},
    // })
    //   .then((response) => {
    //     //console.log(response.data);
    //     console.log("返回机器码:" + JSON.stringify(response.data));
    //     this.deviceNum = response.data;
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  },
  methods: {
    login_check() {
      var that = this;
      this.$axios({
        method: "GET",
        url: this.apiTp5Url + "/getCheck",
        params: {
          username: this.username,
          password: this.password,
          deviceNum: this.deviceNum,
        },
      })
        .then((response) => {
          //console.log(response.data);
          if (response.data.status == 1) {
            console.log("返回:" + JSON.stringify(response.data.orgInfo));
            this.setCookie("account_id", response.data.account_id, 120);
            this.setCookie("org_id", response.data.org_id, 120);
            this.setCookie("account_type", response.data.account_type, 120);

            localStorage.setItem(
              "orgInfo",
              JSON.stringify(response.data.orgInfo)
            );
            this.$message({
              message: "登录成功",
              type: "success",
              duration: 1000,
              onClose: function () {
                //记住密码

                if (that.memory) {
                  localStorage.setItem("memory", "记住密码");
                  localStorage.setItem("username", that.username);
                  localStorage.setItem("password", that.password);
                } else {
                  localStorage.setItem("memory", "取消记住密码");
                  localStorage.removeItem("username");
                  localStorage.removeItem("password");
                }
                that.$router.push({ path: "/index" });
                //window.location.href = "/#/index";
              },
            });
          } else {
            this.$message({
              message: response.data.msg,
              type: "warning",
              duration: 1000,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.com-container {
  max-width: 1920px;
  height: 100%;
  margin: 0 auto;
  background: url("../assets/images/bg.jpg") no-repeat center top;
  background-size: 100% 100%;
}
#login {
  position: absolute;
  top: 6%;
  right: 20%;
  width: 500px;
}
#login .login-box {
  width: 100%;
  position: relative;
}
#login .login-box .i-content {
  top: 195px;
  left: 120px;
  position: absolute;
  width: 250px;
  color: #2eb8be;
  font-size: 16px;
}
#login .login-box .i-content .i-possword {
  margin-top: 50px;
}
#login .login-box input[type="text"],
#login .login-box input[type="password"] {
  line-height: 35px;
  height: 35px;
  border: none;
  outline: none;
}
#login .login-box .i-content .memory {
  margin-top: 30px;
}
#login .login-box .i-content .el-checkbox__input {
  vertical-align: middle;
  zoom: 1.5;
}
#login .login-box .i-content .memory span {
  display: inline-block;
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px white inset !important;
}

input[type="checkbox"] {
  width: 15px;
  height: 15px;
  line-height: 15px;
  background-color: #fff;
  -webkit-appearance: none;

  border-radius: 2px;
  outline: none;
  cursor: pointer;
  margin-right: 8px;
}
input[type="checkbox"]:checked {
  background: #096;
}
</style>
<style >
.el-checkbox__input {
  zoom: 1.5;
}
</style>
